import {actions as routerActions} from 'redux-router5';
import {billingActionTypes as actions} from './actionTypes';
import request from '../api/request';
import {handleError} from '../helpers';

export const updatePlanProductSelections = productSelections => dispatch => {
  dispatch({
    type: actions.BILLING_UPDATE_PLAN_PRODUCT_SELECTIONS,
    productSelections,
  });
};

export const changeSelectedFrequency = option => dispatch => {
  dispatch({
    type: actions.BILLING_SELECTED_FREQUENCY_CHANGED,
    selectedFrequency: option,
  });
};

export const selectPlan = plan => dispatch => {
  dispatch({
    type: actions.BILLING_SELECTED_PLAN_CHANGED,
    selectedPlan: plan,
  });
  return dispatch(routerActions.navigateTo('plancheckout.addons'));
};

const sortPlanProducts = planProducts => {
  let users = {};
  let platform = {};
  const addOns = [];
  const otherProducts = [];
  for (let i = 0; i < planProducts.length; i++) {
    const prod = planProducts[i];
    if (
      prod.code === 'mhelpdeskusers' ||
      (prod.planProduct && prod.planProduct.productCode === 'mhelpdeskusers')
    ) {
      users = prod;
    } else if (
      prod.name === 'mHelpDesk Platform' ||
      (prod.planProduct &&
        prod.planProduct.productName === 'mHelpDesk Platform')
    ) {
      platform = prod;
    } else if (
      prod.chargeType === 'OneTimeCharge' ||
      (prod.planProduct && prod.planProduct.productType === 'OneTimeCharge')
    ) {
      otherProducts.push(prod);
    } else {
      addOns.push(prod);
    }
  }

  return {
    users,
    platform,
    otherProducts,
    addOns,
  };
};

export const loadPlanProducts = (planId, interval) => dispatch => {
  dispatch({type: actions.BILLING_SELECTED_PLAN_LOADING});
  return request({
    url: `/plans/${planId}/${interval.toLowerCase()}/products`,
    includePortal: false,
  })
    .then(response => {
      if (response.status !== 200) {
        throw new Error(response.data);
      }
      const planProducts = sortPlanProducts(response.data);
      return dispatch({
        type: actions.BILLING_SELECTED_PLAN_LOADED,
        planProducts,
      });
    })
    .catch(error => {
      handleError('Unable to load plan details', error, dispatch);
    });
};

export const loadPlans = () => dispatch => {
  dispatch({type: actions.BILLING_GET_PLANS_LOADING});
  return request({url: '/plans', includePortal: false})
    .then(response => {
      if (response.status !== 200) {
        throw new Error(response.data);
      }
      dispatch({
        type: actions.BILLING_GET_PLANS_SUCCESS,
        plans: response.data,
      });
    })
    .catch(error => {
      handleError('Unable to load plans', error, dispatch);
    });
};

export const applyCoupon = (planId, coupon) => dispatch => {
  dispatch({type: actions.BILLING_VALIDATE_COUPON_LOADING});
  return request({
    url: `/plans/${planId}/coupons/validate/${coupon}`,
    includePortal: false,
  })
    .then(response => {
      if (!response || response.status === 404) {
        throw new Error('Coupon not found');
      }
      dispatch({
        type: actions.BILLING_VALIDATE_COUPON_COMPLETE,
        coupon: response.data,
      });
    })
    .catch(error => {
      dispatch({type: actions.BILLING_VALIDATE_COUPON_COMPLETE, coupon: null});
      if (coupon) handleError('Invalid coupon code', error, dispatch);
    });
};

export const createCustomer = ({
  productSelections,
  planProducts,
  selectedPlan,
  selectedFrequency,
  verifiedCoupon,
}) => dispatch => {
  dispatch({type: actions.BILLING_CUSTOMER_CREATING});

  const options = [];
  for (const key in productSelections.addOns) {
    if (productSelections.addOns[key].selected) {
      options.push({
        planProductId: key,
        quantity: productSelections.addOns[key].quantity,
      });
    }
  }

  options.push({
    planProductId: planProducts.users.planProductId,
    quantity:
      productSelections.numUsers === -1 ? 999999 : productSelections.numUsers,
  });

  for (const key in productSelections.otherProducts) {
    if (!!productSelections.otherProducts[key]) {
      options.push({
        planProductId: key,
      });
    }
  }

  const body = {
    planId: selectedPlan.planId,
    frequency: selectedFrequency,
    couponCode: verifiedCoupon && verifiedCoupon.code,
    options,
  };

  return request({url: '/subscription', method: 'POST', body})
    .then(response => {
      if (!response || response.status === 500 || !response.data) {
        throw new Error('Unable to process subscription');
      }

      dispatch({
        type: actions.BILLING_CUSTOMER_CREATED,
        subscriptionInfo: {
          ...response.data,
          ...sortPlanProducts(response.data.currentProducts),
        },
      });
      return response.data;
    })
    .catch(error => {
      dispatch({
        type: actions.BILLING_CUSTOMER_CREATED,
        subscriptionInfo: null,
      });
      handleError('Invalid subscription', error, dispatch);
    });
};

export const activateSubscription = () => dispatch => {
  return request({url: '/subscription?Activate=true', method: 'PUT'})
    .then(response => {
      if (response.status !== 200) {
        throw new Error('Unable to activate subscription');
      }
      return true;
    })
    .catch(error => {
      handleError('Plan activation error', error, dispatch);
    });
};



// WEBPACK FOOTER //
// ./src/actions/billingActions.js